/**
 * Sparkline — the inline trend mark used by the serving stat tiles and the
 * models table. No axes, no labels: it says "shape", the number beside it
 * says "how much". Flat when every value is equal, rather than a
 * misleading full-height line.
 */

import { CHART_INK } from '@/components/evals/chartStyle'

interface SparklineProps {
  values: number[]
  width?: number
  height?: number
}

export function Sparkline({
  values,
  width = 44,
  height = 16,
}: SparklineProps): React.JSX.Element | null {
  if (values.length < 2) return null
  const max = Math.max(...values)
  const min = Math.min(...values)
  const points = values
    .map((value, index) => {
      const x = (index / (values.length - 1)) * width
      const y = height - ((value - min) / (max - min || 1)) * (height - 4) - 2
      return `${x.toFixed(1)},${y.toFixed(1)}`
    })
    .join(' ')
  return (
    <svg width={width} height={height} className="block opacity-60" aria-hidden>
      <polyline points={points} fill="none" stroke={CHART_INK} strokeWidth={1} />
    </svg>
  )
}
